import { render, staticRenderFns } from "./warnRule.vue?vue&type=template&id=0dfeee2b&scoped=true&"
import script from "./warnRule.vue?vue&type=script&lang=js&"
export * from "./warnRule.vue?vue&type=script&lang=js&"
import style0 from "./warnRule.vue?vue&type=style&index=0&id=0dfeee2b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfeee2b",
  null
  
)

export default component.exports